// This sets the public path to the root of the site, so that the
// dynamically loaded chunks can be found.
// See https://webpack.js.org/guides/public-path/#on-the-fly

const root_element_id = "doover_home_root";
const domContainer = document.getElementById(root_element_id);
__webpack_public_path__ =
  domContainer?.getAttribute("__webpack_public_path__") ?? "/";

// Add a trailing slash if it doesn't exist - this seems to be a problem in some deployment cases
__webpack_public_path__ = __webpack_public_path__.replace(/\/?$/, "/");

// This is the path to the remote access script, which is loaded dynamically
window.dooverRemoteAccess_remoteUrl =
  __webpack_public_path__ + "dooverRemoteAccess.js";

import("./bootstrap");
